<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import ViewDetails from '../../ViewDetails/index.vue';
import InvoicePreview from '../../InvoicePreview/index.vue';
export default {
	components: {
		ViewDetails,
			InvoicePreview,
	},
	props: {},
	watch: {},
	data() {
		return {
			//提交状态 0提交成功 1开票成功 2提交失败
			SubmitState: 1,
			//查看详情
			HuanqViewDetails: false,
			//预览发票
			HuanqInvoicePreview: false,
		};
	},

	mounted() {},
	created() {},
	methods: {
		//查看详情回调
		closediagViewDetails(e) {
			this.HuanqViewDetails = false;
		},
		//预览发票回调
		closediagInvoicePreview(e) {
			this.HuanqInvoicePreview = false;
		},
		// 继续新增确认单
		OptionNoteclick() {
			this.$emit('OptionNoteclick', 1);
		}, //关闭页面
		switchInterfaceHuid() {
			this.$emit('switchInterfaceHuid', 0);
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
